function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from 'react';
import { Accordion as BSAccordion, Card, Button, useAccordionToggle, AccordionContext } from 'react-bootstrap';
import noop from 'lodash/noop';
import Icon from '../icon/Icon';
// import Button from '../button/Button';
var AccordionToggle = function(props) {
    var eventKey = props.eventKey, toggleLabel = props.toggleLabel, onToggle = props.onToggle;
    var currentEventKey = useContext(AccordionContext);
    var isCurrentEventKey = currentEventKey === eventKey;
    var decoratedOnClick = useAccordionToggle(eventKey, function() {
        onToggle(!isCurrentEventKey ? eventKey : null);
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "AccordionToggle"
    }, /*#__PURE__*/ React.createElement(BSAccordion.Toggle, {
        id: "label",
        as: Button,
        variant: "link",
        eventKey: eventKey,
        onClick: decoratedOnClick
    }, toggleLabel, /*#__PURE__*/ React.createElement(Icon, {
        icon: isCurrentEventKey ? 'caret-up' : 'caret-down'
    })));
};
var Accordion = function(props) {
    var children = props.children, rest = _object_without_properties(props, [
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(BSAccordion, _object_spread({
        bsPrefix: "Accordion"
    }, rest), children);
};
var AccordionCard = function(props) {
    var toggleLabel = props.toggleLabel, children = props.children, eventKey = props.eventKey, _props_onToggle = props.onToggle, onToggle = _props_onToggle === void 0 ? noop : _props_onToggle;
    return /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Header, null, /*#__PURE__*/ React.createElement(AccordionToggle, {
        onToggle: onToggle,
        toggleLabel: toggleLabel,
        eventKey: eventKey
    })), /*#__PURE__*/ React.createElement(BSAccordion.Collapse, {
        eventKey: eventKey
    }, /*#__PURE__*/ React.createElement(Card.Body, null, children)));
};
Accordion.Card = AccordionCard;
export default Accordion;
